import $ from 'jquery'
import { useEffect } from 'react';
import { Col, Row } from 'antd';

function MainPage() {

    useEffect(() => {

        (function($) {

            var $window = $(window),
                ids = 1,
                queue = {};
        
            /**
             * Resolves a top/bottom value, optionally relative to an element's height
             * or the window height.
             *
             * @param {integer} x Value.
             * @param {integer} eHeight Element height.
             * @param {integer} vHeight Viewport (window) height.
             * @return {integer} Resolved value.
             */
            function resolve(x, eHeight, vHeight) {
        
                if (typeof x === 'string') {
        
                    // Percentage? Relative to element height.
                        if (x.slice(-1) == '%')
                            x = (parseInt(x.substring(0, x.length - 1)) / 100.00) * eHeight;
        
                    // vh? Relative to viewport height.
                        else if (x.slice(-2) == 'vh')
                            x = (parseInt(x.substring(0, x.length - 2)) / 100.00) * vHeight;
        
                    // px? Redundant but okay!
                        else if (x.slice(-2) == 'px')
                            x = parseInt(x.substring(0, x.length - 2));
        
                }
        
                return x;
        
            };
        
            /**
             * Window events.
             */
            $window
                .on('scroll', function() {
        
                    // Get vTop.
                        var vTop = $window.scrollTop();
        
                    // Step through handler queue.
                        $.map(queue, function(o) {
        
                            // Clear existing timeout.
                                window.clearTimeout(o.timeoutId);
        
                            // Call handler after timeout delay.
                                o.timeoutId = window.setTimeout(function() {
                                    (o.handler)(vTop);
                                }, o.options.delay);
        
                        });
        
                })
                .on('load', function() {
                    $window.trigger('scroll');
                });
        
            /**
             * Activates scrollex on an element.
             *
             * @param {object} userOptions Options.
             * @return {jQuery} jQuery object.
             */
            $.fn.scrollex = function(userOptions) {
        
                var $this = $(this);
        
                // No elements?
                    if (this.length == 0)
                        return $this;
        
                // Multiple elements?
                    if (this.length > 1) {
        
                        for (var i=0; i < this.length; i++)
                            $(this[i]).scrollex(userOptions);
        
                        return $this;
        
                    }
        
                // Already scrollexed?
                    if ($this.data('_scrollexId'))
                        return $this;
        
                // Vars.
                    var	id, options, test, handler, o;
        
                // Build object.
        
                    // ID.
                        id = ids++;
        
                    // Options.
                        options = $.extend({
        
                            // Top.
                                top: 0,
        
                            // Bottom.
                                bottom: 0,
        
                            // Delay.
                                delay: 0,
        
                            // Mode ('default', 'top', 'middle', 'bottom', 'top-only', 'bottom-only').
                                mode: 'default',
        
                            // Enter function.
                                enter: null,
        
                            // Leave function.
                                leave: null,
        
                            // Initialize function.
                                initialize: null,
        
                            // Terminate function.
                                terminate: null,
        
                            // Scroll function.
                                scroll: null
        
                        }, userOptions);
        
                    // Test.
                        switch (options.mode) {
        
                            // top: Top viewport edge must fall within element's contact area.
                                case 'top':
        
                                    test = function(vTop, vMiddle, vBottom, eTop, eBottom) {
                                        return (vTop >= eTop && vTop <= eBottom);
                                    };
        
                                    break;
        
                            // bottom: Bottom viewport edge must fall within element's contact area.
                                case 'bottom':
        
                                    test = function(vTop, vMiddle, vBottom, eTop, eBottom) {
                                        return (vBottom >= eTop && vBottom <= eBottom);
                                    };
        
                                    break;
        
                            // middle: Midpoint between top/bottom viewport edges must fall within element's contact area.
                                case 'middle':
        
                                    test = function(vTop, vMiddle, vBottom, eTop, eBottom) {
                                        return (vMiddle >= eTop && vMiddle <= eBottom);
                                    };
        
                                    break;
        
                            // top-only: Top viewport edge must be visible
                                case 'top-only':
        
                                    test = function(vTop, vMiddle, vBottom, eTop, eBottom) {
                                        return (vTop <= eTop && eTop <= vBottom);
                                    };
        
                                    break;
        
                            // bottom-only: Bottom viewport edge must be visible
                                case 'bottom-only':
        
                                    test = function(vTop, vMiddle, vBottom, eTop, eBottom) {
                                        return (vBottom >= eBottom && eBottom >= vTop);
                                    };
        
                                    break;
        
                            // default: Element's contact area must fall within the viewport.
                                default:
                                case 'default':
        
                                    test = function(vTop, vMiddle, vBottom, eTop, eBottom) {
                                        return (vBottom >= eTop && vTop <= eBottom);
                                    };
        
                                    break;
        
                        }
        
                    // Handler.
                        handler = function(vTop) {
        
                            var	currentState = this.state,
                                newState = false,
                                offset = this.$element.offset(),
                                vHeight, vMiddle, vBottom,
                                eHeight, eTop, eBottom;
        
                            // Viewport values.
                                vHeight = $window.height();
                                vMiddle = vTop + (vHeight / 2);
                                vBottom = vTop + vHeight;
        
                            // Element values.
                                eHeight = this.$element.outerHeight();
                                eTop = offset.top + resolve(this.options.top, eHeight, vHeight);
                                eBottom = (offset.top + eHeight) - resolve(this.options.bottom, eHeight, vHeight);
        
                            // Determine if there's been a state change.
                                newState = this.test(vTop, vMiddle, vBottom, eTop, eBottom);
        
                                if (newState != currentState) {
        
                                    // Update state.
                                        this.state = newState;
        
                                    // Call appropriate function.
                                        if (newState) {
        
                                            if (this.options.enter)
                                                (this.options.enter).apply(this.element);
        
                                        }
                                        else {
        
                                            if (this.options.leave)
                                                (this.options.leave).apply(this.element);
        
                                        }
        
                                }
        
                            // Call scroll function.
                                if (this.options.scroll)
                                    (this.options.scroll).apply(this.element, [
                                        (vMiddle - eTop) / (eBottom - eTop)
                                    ]);
        
                        };
        
                    // Object.
                        o = {
                            id: id,
                            options: options,
                            test: test,
                            handler: handler,
                            state: null,
                            element: this,
                            $element: $this,
                            timeoutId: null
                        };
        
                // Add object to queue.
                    queue[id] = o;
        
                // Add scrollex ID to element.
                    $this.data('_scrollexId', o.id);
        
                // Call initialize.
                    if (o.options.initialize)
                        (o.options.initialize).apply(this);
        
                return $this;
        
            };
        
            /**
             * Deactivates scrollex on an element.
             *
             * @return {jQuery} jQuery object.
             */
            $.fn.unscrollex = function() {
        
                var $this = $(this);
        
                // No elements?
                    if (this.length == 0)
                        return $this;
        
                // Multiple elements?
                    if (this.length > 1) {
        
                        for (var i=0; i < this.length; i++)
                            $(this[i]).unscrollex();
        
                        return $this;
        
                    }
        
                // Vars.
                    var id, o;
        
                // Not scrollexed?
                    id = $this.data('_scrollexId');
        
                    if (!id)
                        return $this;
        
                // Get object from queue.
                    o = queue[id];
        
                // Clear timeout.
                    window.clearTimeout(o.timeoutId);
        
                // Remove object from queue.
                    delete queue[id];
        
                // Remove scrollex ID from element.
                    $this.removeData('_scrollexId');
        
                // Call terminate.
                    if (o.options.terminate)
                        (o.options.terminate).apply(this);
        
                return $this;
        
            };
        
        })($);

        /* jquery.scrolly v1.0.0-dev | (c) @ajlkn | MIT licensed */
        (function (e) {
            function u(s, o) {
                var u, a, f;
                if ((u = e(s))[t] == 0) return n;
                a = u[i]()[r];
                switch (o.anchor) {
                    case "middle":
                        f = a - (e(window).height() - u.outerHeight()) / 2;
                        break;
                    default:
                    case r:
                        f = Math.max(a, 0);
                }
                return typeof o[i] == "function" ? (f -= o[i]()) : (f -= o[i]), f;
            }
            var t = "length",
                n = null,
                r = "top",
                i = "offset",
                s = "click.scrolly",
                o = e(window);
            e.fn.scrolly = function (i) {
                var o,
                    a,
                    f,
                    l,
                    c = e(this);
                if (this[t] == 0) return c;
                if (this[t] > 1) {
                    for (o = 0; o < this[t]; o++) e(this[o]).scrolly(i);
                    return c;
                }
                l = n;
                f = c.attr("href");
                if (f.charAt(0) != "#" || f[t] < 2) return c;
                a = $.extend({ anchor: r, easing: "swing", offset: 0, parent: e("body,html"), pollOnce: !1, speed: 1e3 }, i);
                if(a.pollOnce) {
                    l = u(f, a)
                }
                c.off(s).on(s, function (e) {
                    var t = l !== n ? l : u(f, a);
                    if (t !== n) {
                        e.preventDefault();
                        a.parent.stop().animate({ scrollTop: t }, a.speed, a.easing);
                    }
                });
            };
        })($);
        


        var	$window = $(window),
		$body = $('body'),
		$sidebar = $('#sidebar');


        window.setTimeout(function() {
            $body.removeClass('is-preload');
        }, 100);
	

	// // Forms.

	// 	// Hack: Activate non-input submits.
	// 		$('form').on('click', '.submit', function(event) {

	// 			// Stop propagation, default.
	// 				event.stopPropagation();
	// 				event.preventDefault();

	// 			// Submit form.
	// 				$(this).parents('form').submit();

	// 		});

	// Sidebar.
		if ($sidebar.length > 0) {

			var $sidebar_a = $sidebar.find('a');

			$sidebar_a
				.addClass('scrolly')
				.on('click', function() {

					var $this = $(this);

					// External link? Bail.
						if ($this.attr('href').charAt(0) != '#')
							return;

					// Deactivate all links.
						$sidebar_a.removeClass('active');

					// Activate link *and* lock it (so Scrollex doesn't try to activate other links as we're scrolling to this one's section).
						$this
							.addClass('active')
							.addClass('active-locked');

				})
				.each(function() {

					var	$this = $(this);
					var id = $this.attr('href');
                    if (id == "#") {
                        return;
                    }
					var $section = $(id);

					// No section for this link? Bail.
						if ($section.length < 1)
							return;

					// Scrollex.
						$section.scrollex({
							mode: 'middle',
							top: '-20vh',
							bottom: '-20vh',
							initialize: function() {

								// Deactivate section.
                                if($section.attr('id') == 'intro') {
                                    return;
                                }
                                    
								$section.addClass('inactive');

							},
							enter: function() {

								// Activate section.
									$section.removeClass('inactive');

								// No locked links? Deactivate all links and activate this section's one.
									if ($sidebar_a.filter('.active-locked').length == 0) {

										$sidebar_a.removeClass('active');
										$this.addClass('active');

									}

								// Otherwise, if this section's link is the one that's locked, unlock it.
									else if ($this.hasClass('active-locked'))
										$this.removeClass('active-locked');

							}
						});

				});

		}

	// Scrolly.
		$('.scrolly').scrolly({
			speed: 1000,
			offset: function() {
				return 0;
			}
		});

	// Spotlights.
		$('.spotlight-section')
			.scrollex({
				mode: 'middle',
				top: '-10vh',
				bottom: '-10vh',
				initialize: function() {

					// Deactivate section.
						$(this).addClass('inactive');

				},
				enter: function() {

					// Activate section.
						$(this).removeClass('inactive');

				}
			})
			.each(function() {

				var	$this = $(this),
					$image = $this.find('.image'),
					$img = $image.find('img'),
					x;

				// Assign image.
					$image.css('background-image', 'url(' + $img.attr('src') + ')');

				// Set background position.
					if (x = $img.data('position'))
						$image.css('background-position', x);

				// Hide <img>.
					$img.hide();

			});

	// Features.
		$('.features')
			.scrollex({
				mode: 'middle',
				top: '-20vh',
				bottom: '-20vh',
				initialize: function() {

					// Deactivate section.
						$(this).addClass('inactive');

				},
				enter: function() {

					// Activate section.
						$(this).removeClass('inactive');

				}
			});
    
    });

    return (
        <body className="is-preload">

		
			<section id="sidebar">
				<div className="inner">
                    <div className="sidebar-logo-container">
                        <a href="#" className="image sidebar-logo"><img src="images/logo.png" width={"207px"} height={"122px"} alt="" data-position="center center" /></a>
                    </div>
					<nav>
						<ul>
							<li><a href="#intro">Kigurumeet</a></li>
							<li><a href="#one">Meet the Kigus</a></li>
							<li><a href="#two">Activities</a></li>
							<li><a href="#three">Contact</a></li>
						</ul>
					</nav>
				</div>
			</section>

		
			<div id="wrapper">

				
					<section id="intro" className="wrapper style1 fullscreen fade-up">
						<div className="inner">
							<h1>Kigurumeet</h1>
							<p>Kigurumeet is a meetup project created by a group of active Kigurumi performers based in the US.</p>
							<ul className="actions">
								<li><a href="#one" className="button scrolly">Kigurumeet 2022 Event Page</a></li>
							</ul>
						</div>
					</section>

				
                    {/* TODO: When mouse hovers the image, show kigu name */}

					<section id="one" className="wrapper style2 spotlights">
                        <section className='spotlight-row'>

                        
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/001.jpg" alt="" data-position="center center" /></a>
                            </section>
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/002.jpg" alt="" data-position="top center" /></a>
                            </section>
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/003.jpg" alt="" data-position="center center" /></a>
                            </section>
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/004.jpg" alt="" data-position="top center" /></a>
                            </section>
                        
                        </section>
                        <section className='spotlight-row'>
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/005.jpg" alt="" data-position="25% 25%" /></a>
                            </section>
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/006.jpg" alt="" data-position="25% 25%" /></a>
                            </section>
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/007.jpg" alt="" data-position="25% 25%" /></a>
                            </section>
                            <section className='spotlight-section'>
                                <a href="#" className="image"><img src="images/kigu/008.jpg" alt="" data-position="25% 25%" /></a>
                            </section>
                        </section>
						
                        
					</section>

				
					<section id="two" className="wrapper style3 fade-up">
						<div className="inner">
							<h2>What we do</h2>
							<p>Phasellus convallis elit id ullamcorper pulvinar. Duis aliquam turpis mauris, eu ultricies erat malesuada quis. Aliquam dapibus, lacus eget hendrerit bibendum, urna est aliquam sem, sit amet imperdiet est velit quis lorem.</p>
							<div className="features">
								<section>
									<span className="icon solid major fa-code"></span>
									<h3>Lorem ipsum amet</h3>
									<p>Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.</p>
								</section>
								<section>
									<span className="icon solid major fa-lock"></span>
									<h3>Aliquam sed nullam</h3>
									<p>Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.</p>
								</section>
								<section>
									<span className="icon solid major fa-cog"></span>
									<h3>Sed erat ullam corper</h3>
									<p>Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.</p>
								</section>
								<section>
									<span className="icon solid major fa-desktop"></span>
									<h3>Veroeros quis lorem</h3>
									<p>Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.</p>
								</section>
								<section>
									<span className="icon solid major fa-link"></span>
									<h3>Urna quis bibendum</h3>
									<p>Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.</p>
								</section>
								<section>
									<span className="icon major fa-gem"></span>
									<h3>Aliquam urna dapibus</h3>
									<p>Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.</p>
								</section>
							</div>
							<ul className="actions">
								<li><a href="generic.html" className="button">Learn more</a></li>
							</ul>
						</div>
					</section>

				
					<section id="three" className="wrapper style1 fade-up">
						<div className="inner">
							<h2>Contact</h2>
                            <h3>Social</h3>
											<ul className="icons">
												<li><a href="https://twitter.com/kigurumeet" className="icon brands fa-twitter"><span className="label">Twitter</span></a></li>
                                                <li><a href="https://discord.gg/mFMcJtCgyg" className="icon brands fa-discord"><span className="label">Discord</span></a></li>
												<li><a href="#" className="icon brands fa-facebook-f"><span className="label">Facebook</span></a></li>
												<li><a href="#" className="icon brands fa-instagram"><span className="label">Instagram</span></a></li>
												<li><a href="#" className="icon brands fa-linkedin-in"><span className="label">LinkedIn</span></a></li>
											</ul>
							
						</div>
					</section>

			</div>

		
			<footer id="footer" className="wrapper style1-alt">
				<div className="inner">
					<ul className="menu">
						<li>&copy; Kigurumeet. All rights reserved.</li><li>Design: <a href="http://html5up.net">HTML5 UP</a></li>
					</ul>
				</div>
			</footer>

		
			

	</body>
    )
}

export default MainPage;